<template>
    <spinner v-if="cargando || lazy"/>
    <div v-else>
        <md-tabs md-theme="primary" v-on:md-changed="pestana">
            <md-tab id="kits" md-label="Kit"></md-tab>
            <md-tab id="individuales" md-label="Individuales"></md-tab>
            <md-tab id="prepagados" md-label="Mant. Prepagados" v-if="cupones.length"></md-tab>
        </md-tabs>
        <div class="pt-2 sub-section">
            <div v-if="panel==='kits'" :key="1">
                <boton-accesorio v-for="item in filtroKit" :key="item.id" :datos="item" v-model="formulario.kit"/>
                <div class="alert alert-elevate alert-light alert-bold" role="alert" v-if="filtroKit.length===0">
                    <div class="alert-text">No hay <b>Kits</b> de accesorios registrados</div>
                </div>
            </div>
            <div v-else-if="panel==='individuales'" :key="2">
                <boton-accesorio v-for="item in filtroIndividuales" :key="item.id" :datos="item" v-model="formulario.individuales"/>
                <div class="alert alert-elevate alert-light alert-bold" role="alert" v-if="filtroIndividuales.length===0">
                    <div class="alert-text">No hay accesorios registrados</div>
                </div>
            </div>
          <div v-else :key="3">
            <div class="alert alert-custom alert-outline-primary fade show" role="alert">
              <div class="alert-text">
                Kia Ecuador realiza sus mantenimientos preventivos cada 10.000 km, a continuación se puede realizar la compra de mantenimientos prepagados según los siguientes paquetes.
              </div>
            </div>
            <boton-cupon v-for="item in cupones" :key="item.id" :datos="item" v-model="formulario.cupones"/>
            <div class="alert alert-elevate alert-light alert-bold" role="alert" v-if="cupones.length===0">
              <div class="alert-text">No hay mantenimientos prepagados</div>
            </div>
          </div>
        </div>
        <div class="pt-5 d-flex justify-content-between">
            <button type="button" class="btn btn-secondary btn-font-sm" v-on:click="atras"><i class="flaticon2-back"></i> Regresar</button>
            <button type="button" class="btn btn-primary btn-font-sm" v-on:click="siguiente"> Continuar <i class="flaticon2-next"></i></button>
        </div>
    </div>
</template>

<script>
    import BotonAccesorio from "../../../componentes/boton-accesorio";
    import BotonCupon from "../../../componentes/boton-cupon";
    import spinner from "./spinner";
    export default {
        name: "acesorios",
        components:{
            BotonAccesorio,
            BotonCupon,
            spinner
        },
        data:()=>({
            panel:null,
            formulario:{
                individuales:[],
                kit:[],
                cupones:[],
            },
            lazy:true,
        }),
        watch:{
            "formulario.individuales":function(){
                this.$emit('input',this.formulario);
            },
            "formulario.kit":function(){
                this.$emit('input',this.formulario);
            },
            "formulario.cupones":function(){
              this.$emit('input',this.formulario);
            },
        },
        computed:{
            filtroIndividuales:function(){
                return this.individuales.filter(item => item.bdt9===false);
            },
            filtroKit:function(){
                return this.kits.filter(item => item.bdt9===false);
            },
        },
        props:{
            individuales:{
                type:Array
            },
            kits:{
                type:Array
            },
            cupones:{
                type:Array
            },
            value:{
                type:Object
            },
            cargando:{
                type:Boolean
            }
        },
        methods:{
            pestana:function(index){
                this.panel=index;
            },
            atras:function(){
                this.$store.commit('setSubActual',2);
            },
            siguiente:function(){
                this.$store.commit('setSubActual',4);
            },
        },
        created() {
            this.formulario=this.value;
            let individuales=this.individuales.length;
            let kits=this.kits.length;
            if(individuales)
                this.panel=0;
            if(kits)
                this.panel=1;
            if(individuales+kits===0)
                this.siguiente();
        },
        mounted() {
            setTimeout(()=>{
                this.lazy=false;
            },600)
        }
    }
</script>

<style scoped>

</style>
